import React from 'react';
import {
  downloadFile,
  isViewableResourceExtension,
  updateResourceDownloadsCount
} from '../functions/functions';
import Iframe from 'react-iframe';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const ResourceViewer = ({
  objectId,
  locationPath,
  isPhysical,
  isACorrectLink,
  isResourceDownloadAvailable,
  fileName,
  fileExtension,
  resourceImage
}) => {
  const { t, i18n } = useTranslation();
  useEffect(() => {
    i18n.changeLanguage(localStorage.getItem('lang'));
  }, [i18n]);

  return (
    <>
      {isACorrectLink ? (
        <div
          id="resource-view"
          className="d-flex justify-content-center resource-view"
          style={{ backgroundImage: resourceImage }}
        >
          <a
            href={locationPath}
            rel="noopener noreferrer"
            target="_blank"
            className="align-self-center fw-400 py-2 px-4 mx-3 btn resource-visualization waves-effect waves-themed"
          >
            <i
              className="far fa-external-link-square"
              style={{ fontSize: '20px' }}
            />
            <span className="download-font">{t('ver_nueva_pestana')}</span>
          </a>
        </div>
      ) : isPhysical ? (
        isResourceDownloadAvailable &&
        isViewableResourceExtension(fileExtension) ? (
          <Iframe
            url={locationPath}
            display="initial"
            className="resource-view"
          />
        ) : (
          <div
            id="resource-view"
            className="d-flex justify-content-center resource-view"
            style={{
              backgroundImage: resourceImage
            }}
          >
            <button
              onClick={() => {
                updateResourceDownloadsCount(objectId);
                downloadFile(locationPath, fileName, fileExtension);
              }}
              rel="noopener noreferrer"
              className="align-self-center fw-400 py-2 px-4 mx-3 btn resource-visualization waves-effect waves-themed"
            >
              <i
                className="fas fa-cloud-download mr-2"
                style={{ fontSize: '20px' }}
              />
              <span className="download-font">{t('descargar_recurso')}</span>
            </button>
          </div>
        )
      ) : (
        <div
          id="resource-view"
          className="d-flex justify-content-center resource-view"
          style={{ backgroundImage: resourceImage }}
        >
          <span className="align-self-center fw-400 py-2 px-4 mx-3 btn resource-visualization btn-pills waves-effect waves-themed">
            <i
              className="fas fa-times-circle mr-2"
              style={{ fontSize: '20px' }}
            />
            <span className="download-font">
              {t('visualizacion_no_disponible')}
            </span>
          </span>
        </div>
      )}
    </>
  );
};

export default ResourceViewer;
